import styled from 'styled-components';

/**
 * Burbuja de ayuda con el patrón que ya usa la casa: el texto viaja en el
 * atributo `data-tooltip` y lo pinta el CSS con `content: attr(data-tooltip)`
 * (mismo mecanismo y mismos valores visuales que `ButtonIconBackground`, que
 * es donde nació). Aquí cambian tres cosas, y las tres por un motivo:
 *
 * 1. **Sale hacia ARRIBA**. El de origen cae hacia abajo, y sobre un campo de
 *    formulario eso tapa justo el control que se está explicando.
 * 2. **El texto se parte**. El de origen usa `nowrap` porque rotula botones de
 *    una palabra; aquí son frases, así que ancho máximo y varias líneas.
 * 3. **También con `:focus`**, no solo `:hover`. En tablet no hay ratón: al
 *    tocar el botón se enfoca, así que aparece; al tocar fuera se va.
 */
export const HelpButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  margin-left: ${({ theme }) => theme.spacing.xxs};
  cursor: pointer;
  min-width: 1.4rem;
  height: 1.4rem;
  vertical-align: middle;

  /* Área de toque cómoda en tablet sin descolocar la línea de la etiqueta. */
  @media (hover: none) and (pointer: coarse) {
    min-width: 2.4rem;
    height: 2.4rem;
    margin-left: 0;
  }

  &:hover svg circle:first-of-type {
    fill: ${({ theme }) => theme.colors.greyLight};
    stroke: ${({ theme }) => theme.colors.darkGrey};
  }

  &:focus-visible {
    outline: 0.2rem solid ${({ theme }) => theme.colors.black};
    outline-offset: 0.2rem;
    border-radius: 50%;
  }

  &[data-tooltip]:hover::after,
  &[data-tooltip]:focus::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 0.8rem);
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.88);
    color: white;
    padding: 0.6rem 1.1rem;
    border-radius: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.02rem;
    line-height: 1.45;
    width: max-content;
    max-width: 24rem;
    white-space: normal;
    text-align: left;
    z-index: ${({ theme }) => theme.zIndex.tooltip};
    pointer-events: none;
    box-shadow: 0 0.3rem 0.8rem rgba(0, 0, 0, 0.25);
  }

  &[data-tooltip]:hover::before,
  &[data-tooltip]:focus::before {
    content: '';
    position: absolute;
    bottom: calc(100% + 0.1rem);
    left: 50%;
    transform: translateX(-50%);
    border: 0.5rem solid transparent;
    border-top-color: rgba(0, 0, 0, 0.88);
    z-index: ${({ theme }) => theme.zIndex.tooltip};
    pointer-events: none;
  }
`;
